import {isRedirect, redirect} from '@tanstack/react-router'

import {queryClient} from '../api/query-client'
import {isAdmin} from './is-admin'
import {meQueryOptions} from './me-query'

export async function requireAdminBeforeLoad() {
    try {
        const user = await queryClient.ensureQueryData(meQueryOptions)
        if (user == null) {
            throw redirect({to: '/login'})
        }
        if (!isAdmin(user)) {
            throw redirect({to: '/'})
        }
    } catch (error) {
        if (isRedirect(error)) {
            throw error
        }
        throw error
    }
}
